import React, { useState } from "react";
import styled from "styled-components";
import { useAuth } from "../contexts/AuthContext";
import { useTicketSearch } from "../contexts/TicketSearchContext";

const Sidebar = () => {
  const { user, additionalData, logout } = useAuth();
  const { updateFilter, states } = useTicketSearch();
  const [isOpen, setIsOpen] = useState(false);

  const handleFilterChange = (filterName, value) => {
    updateFilter(filterName, value);
  };

  return (
    <>
      <MenuButton onClick={() => setIsOpen(!isOpen)}>
        ☰
      </MenuButton>
      <SidebarContainer isOpen={isOpen}>
        <LogoContainer>
          <Logo src="https://tcsainterno.blob.core.windows.net/public/logo-tcsa-PRINCIPAL-WHITE.png" alt="Logo" />
        </LogoContainer>
        <SectionTitle>Usuario</SectionTitle>
        <p>
          Nombre: <strong>{user?.fullName || "No disponible"}</strong>
        </p>
        <p>
          Perfil: <strong>{additionalData.activeProfile?.name || "No disponible"}</strong>
        </p>
        <SectionTitle>Filtros</SectionTitle>
        <label htmlFor="select-status">Estado:</label>
        <Select
          id="select-status"
          onChange={(e) => handleFilterChange("status", e.target.value)}
          defaultValue="1"
        >
          <option value="">Todos los estados</option>
          {states.map((state) => (
            <option key={state.id} value={state.id}>
              {state.name}
            </option>
          ))}
        </Select>
        <LogoutButton onClick={logout}>Cerrar sesión</LogoutButton>
      </SidebarContainer>
    </>
  );
};

const MenuButton = styled.button`
  display: none;
  position: fixed;
  top: 10px;
  left: 10px;
  background-color: #343a40;
  color: white;
  border: none;
  padding: 10px;
  cursor: pointer;
  z-index: 1100;

  @media (max-width: 768px) {
    display: block;
  }
`;


const SidebarContainer = styled.div`
  width: 200px;
  background-color: #343a40;
  color: white;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  position: fixed;
  height: 100vh;
  top: 0;
  transition: left 0.3s ease;

@media (max-width: 768px) {
    width: 100%; /* Ocupa todo el ancho */
    padding: 20px; /* Asegura que haya separación en móviles */
    display: ${({ isOpen }) => (isOpen ? "block" : "none")}; /* Mostrar u ocultar el Sidebar */
    z-index: 1000; /* Asegúrate de que esté sobre el contenido principal */
}

`;



const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 5px;
`;

const Logo = styled.img`
  max-width: 80%;
  max-height: 80px;
`;

const SectionTitle = styled.h3`
  border-bottom: 1px solid #495057;
  padding-bottom: 5px;
`;

const Select = styled.select`
  width: 100%;
  padding: 10px;
  margin-top: 5px;
  background-color: #495057;
  color: white;
  border: none;
  border-radius: 4px;

  &:focus {
    outline: none;
    border: 1px solid #17a2b8;
  }
`;

const LogoutButton = styled.button`
  margin-top: 10px;
  width: 100%;
  padding: 10px;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: #c82333;
  }
`;

export default Sidebar;
